"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarsCopy = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var CarsFilterCopy_1 = require("../../components/carsFilter/CarsFilterCopy");
var BreadCrumpPage_1 = require("../../components/breadCrumpPage/BreadCrumpPage");
var carsSlice_1 = require("../../redux/slice/carsSlice");
var CarsCopy = function () {
    // var navigate = useNavigate();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_router_dom_1.useSearchParams)(), searchParams = _a[0], setSearchParams = _a[1];
    react_1.default.useEffect(function () {
        var currentParams = Object.fromEntries(searchParams.entries());
        var defaultParams = __assign({ year_from: '2020', price_asc: 'true' }, currentParams);
        // Update search params with defaults
        setSearchParams(defaultParams, { replace: false });
        // Dispatch loadCars with all parameters
        dispatch((0, carsSlice_1.loadCars)(defaultParams));
    }, []); // Only run once on mount
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "page" },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                    { name: 'Главная', url: '/' },
                    { name: 'Спецпредолжение', url: '/cars_copy' },
                ] }),
            react_1.default.createElement(CarsFilterCopy_1.CarsFilterCopy, null))));
};
exports.CarsCopy = CarsCopy;
